/** @file useT: React hook returning t() for the language held in the settings store. */
import { createT } from '@pose2d/i18n/createT';
import type { Translate } from '@pose2d/i18n/types';
import { useMemo } from 'react';
import { useStore } from 'zustand';
import { settingsStore } from '../../stores/settingsStore';
import { catalogs } from './catalogs';

/** Re-renders the caller when `settings.lang` changes. */
export function useT(): Translate {
  const lang = useStore(settingsStore, (s) => s.lang);
  return useMemo(() => createT(catalogs, lang), [lang]);
}
